import { render, staticRenderFns } from "./editProviderPopularGame.vue?vue&type=template&id=75d7b98e&lang=pug"
import script from "./editProviderPopularGame.vue?vue&type=script&lang=js"
export * from "./editProviderPopularGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports